import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { IMicaChatTelefonoData } from '@core/interfaces/entidades/telefono.entidad';

@Component({
  selector: 'app-mica-chat-configuracion',
  imports: [DatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './mica-chat-configuracion.html',
})
export class MicaChatConfiguracion {
  telefonos = input.required<IMicaChatTelefonoData[]>();
  toggleComprobantes = output<IMicaChatTelefonoData>();
}
